module.exports = __webpack_public_path__ + "img/skinbox-black-small.0e32247b.png";